export default __webpack_public_path__ + "static/media/icon-mitigation-notification.af6dbb78.svg";